import React, { Component } from 'react'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import flowRight from 'lodash/flowRight'
import { FormattedMessage } from 'react-intl'

import {
  makeSelectDateById
} from 'logic/dates'

import messages from 'i18n/messages'

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

class EventMenuInfo extends Component {

  scrollToMap = () => scrollToRef(this.props.mapRef)

  render () {
    const { date } = this.props
    if (!date) return <div />

    return (
      <div className="tt-location-side-nav">
        <div className="tt-about-box tt-location-box">
          <div className="pb-4">
            <small className="small-title"><FormattedMessage {...messages.venue} /></small><br />
            <p>
              {date.location.street}
              <br />
              {date.location.postcode} {date.location.city}
            </p>
            <p>
              {date.location.lng
                ? <a href="javascript:void(0);" onClick={this.scrollToMap}>
                    <FormattedMessage {...messages.showOnMap} />
                  </a>
                : null
              }
            </p>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  date: makeSelectDateById(props => props.dateId),
})

const enhance = flowRight(
  connect(mapStateToProps),
)

export default enhance(EventMenuInfo)
